/*
 * サブシステム名：OTM受付一覧編集
 * 機能名：受付一覧編集
 */
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
// import d2fmt from '@/ddv2.library/utils/formatter'
import header from '@/ddv2.library/header'

import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdListHeader from '@/components/DdListHeader'
import DdRadioButton from '@/components/DdRadioButton'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdTextBox from '@/components/DdTextBox'
import DdTransparentButton from '@/components/DdTransparentButton'

export default {
  name: 'OtmDeliveryLedger',
  mixins: [flowMixin],
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdDateRangeBox,
    DdIconButtonWithTooltip,
    DdListHeader,
    DdRadioButton,
    DdSpreadSheet,
    DdTextBox,
    DdTransparentButton
  },
  data: () => ({
    // 一覧制御用
    rows: [],
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
    },
    conditionDetails: [
      { key: 'sagyoYmdFromTo', name: '配送日', value: 'sagyoYmdFromTo', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'tokuisakiId', name: '顧客', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'tantoshaId', name: '担当者', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' }
    ],
    // ヘッダー定義
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisaki,

    // 制御用
    modeKengen: 0,
    pageCount: 0,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '60vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 配送日
    'conditions.sagyoYoteiStartYmd': function (n) {
      var sagyoYmdFromTo = ![undefined, null, ''].includes(this.conditions.sagyoYoteiStartYmdString) ? this.conditions.sagyoYoteiStartYmdString.slice(-5) : ''
      sagyoYmdFromTo = sagyoYmdFromTo + (![undefined, null, ''].includes(this.conditions.sagyoYoteiEndYmdString) ? '～' + this.conditions.sagyoYoteiEndYmdString.slice(-5) : '')
      this.conditions.sagyoYmdFromTo = sagyoYmdFromTo
    },
    'conditions.sagyoYoteiEndYmd': function (n) {
      var sagyoYmdFromTo = ![undefined, null, ''].includes(this.conditions.sagyoYoteiStartYmdString) ? this.conditions.sagyoYoteiStartYmdString.slice(-5) : ''
      sagyoYmdFromTo = sagyoYmdFromTo + (![undefined, null, ''].includes(this.conditions.sagyoYoteiEndYmdString) ? '～' + this.conditions.sagyoYoteiEndYmdString.slice(-5) : '')
      this.conditions.sagyoYmdFromTo = sagyoYmdFromTo
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      JininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 得意先フィルター
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 人員フィルター
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.JininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    isMultiSaveButtonDisabled () {
      return false
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    // **************************************************
    // 初期化
    // **************************************************
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthacchakuchi', 'msthinmei'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          console.log('★★★', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('OtmDeliveryLedger.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('OtmDeliveryLedger.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('OtmDeliveryLedger.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('OtmDeliveryLedger.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    initBindVariables: function () {
      const d = new Date()
      this.conditions = {
        sagyoYoteiStartYmd: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        sagyoYoteiEndYmd: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        tokuisakiId: null,
        tantoshaId: null
      }
    },

    // --------------------------------------------------
    // 検索ボタン押下
    // --------------------------------------------------
    onSearchButtonClick: function () {
      this.setHeader()

      // ダミーデータ作成
      this.rows.push({
        sagyoYoteiYmd: '2024/10/02',
        hatsuchiNm: 'OTM工場',
        chakuchiNm: '法人課',
        sagyoTantoshaNm: '清田竜太郎',
        hinmeiNm: 'ピクシスエポック',
        denpyoHanyoBiko1: '050635',
        denpyoHanyoBiko2: 'シルバー',
        tokuisakiNm: '医療法人HSR名嘉村クリニック',
        juchuEigyoshoNm: 'T沖縄',
        denpyoHanyoBiko3: 'LA350',
        denpyoHanyoBiko4: 'S28',
        juchuTantoshaNm: '1比嘉',
        denpyoHanyoSbt1: '新',
        denpyoHanyoBiko5: null
      })
      this.rows.push({
        sagyoYoteiYmd: '2024/10/02',
        hatsuchiNm: 'OTM工場',
        chakuchiNm: '法人課',
        sagyoTantoshaNm: '清田竜太郎',
        hinmeiNm: 'ピクシスエポック',
        denpyoHanyoBiko1: '050645',
        denpyoHanyoBiko2: 'シルバー',
        tokuisakiNm: '医療法人HSR名嘉村クリニック',
        juchuEigyoshoNm: 'T沖縄',
        denpyoHanyoBiko3: 'LA350',
        denpyoHanyoBiko4: 'S28',
        juchuTantoshaNm: '1比嘉',
        denpyoHanyoSbt1: '新',
        denpyoHanyoBiko5: null
      })
      this.rows.push({
        sagyoYoteiYmd: '2024/10/02',
        hatsuchiNm: 'OTM工場',
        chakuchiNm: 'コザ',
        sagyoTantoshaNm: '比嘉奨',
        hinmeiNm: 'シエンタGAS',
        denpyoHanyoBiko1: '1053373',
        denpyoHanyoBiko2: 'シルバー',
        tokuisakiNm: '仲吉菜津美',
        juchuEigyoshoNm: 'T沖縄',
        denpyoHanyoBiko3: 'MXPC10',
        denpyoHanyoBiko4: '1L7',
        juchuTantoshaNm: '1比嘉',
        denpyoHanyoSbt1: '新',
        denpyoHanyoBiko5: null
      })
      this.rows.push({
        sagyoYoteiYmd: '2024/10/02',
        hatsuchiNm: 'OTM工場',
        chakuchiNm: 'コザ',
        sagyoTantoshaNm: '仲間寿人',
        hinmeiNm: 'カローラクラス（カ）',
        denpyoHanyoBiko1: '1046898',
        denpyoHanyoBiko2: '白',
        tokuisakiNm: '榮門良人',
        juchuEigyoshoNm: 'T沖縄',
        denpyoHanyoBiko3: 'ZVG13',
        denpyoHanyoBiko4: '089',
        juchuTantoshaNm: '1比嘉',
        denpyoHanyoSbt1: '新',
        denpyoHanyoBiko5: null
      })
      this.rows.push({
        sagyoYoteiYmd: '2024/10/02',
        hatsuchiNm: 'OTM工場',
        chakuchiNm: '松本',
        sagyoTantoshaNm: '金城一輝',
        hinmeiNm: 'ライズHEV',
        denpyoHanyoBiko1: '0063628',
        denpyoHanyoBiko2: '黒',
        tokuisakiNm: '宇座舞華',
        juchuEigyoshoNm: 'T沖縄',
        denpyoHanyoBiko3: 'A202',
        denpyoHanyoBiko4: 'XH3',
        juchuTantoshaNm: '1比嘉',
        denpyoHanyoSbt1: '新',
        denpyoHanyoBiko5: null
      })
    },

    // --------------------------------------------------
    // クリアボタン押下
    // --------------------------------------------------
    onClearButtonClick: function () {
      this.initBindVariables()
      this.rows = []
    },

    // --------------------------------------------------
    // 行追加ボタン押下
    // --------------------------------------------------
    onNewRowButtonClick: function () {
      this.rowAppend(1, false, true)
    },

    // --------------------------------------------------
    // 変更ボタン押下
    // --------------------------------------------------
    onMultiSaveButtonClick: function () {

    },

    /**
     * スプレッドシート制御
     * @returns
     */
    setHeader: function () {
      console.log('setHeader')
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        // const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 得意先
        /*
        var wkTokuisakiList = []
        const mTokuisakiList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
        })
        const tTokuisakiList = mTokuisakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkTokuisakiList = wkTokuisakiList.concat(tTokuisakiList)
        */

        // 商品
        /*
        var wkShohinList = []
        const mShohinList = self.hinmeiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tShohinList = mShohinList.map(elem => {
          return elem.hinmeiNm
        })
        wkShohinList = wkShohinList.concat(tShohinList)
        */

        // 発着地
        /*
        var wkHacchakuchiList = []
        const mHacchakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tHacchakuchiList = mHacchakuchiList.map(elem => {
          return elem.hacchakuchNm
        })
        wkHacchakuchiList = wkHacchakuchiList.concat(tHacchakuchiList)
        */

        // 人員
        /*
        var wkJininList = []
        const mJininList = self.JininList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tJininList = mJininList.map(elem => {
          return elem.jininNmSei
        })
        wkJininList = wkJininList.concat(tJininList)
        */

        // 乗務員
        /*
        var wkJomuinList = []
        const mJomuinList = self.JininList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.jomuFlg === true
        })
        const tJomuinList = mJomuinList.map(elem => {
          return elem.jininNmSei
        })
        wkJomuinList = wkJomuinList.concat(tJomuinList)
        */

        // 営業所
        /*
        var wkEigyoshoList = []
        const mEigyoshoList = this.EigyoshoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.jomuFlg === true
        })
        const tEigyoshoList = mEigyoshoList.map(elem => {
          return elem.hacchakuchNm
        })
        wkEigyoshoList = wkEigyoshoList.concat(tEigyoshoList)
        */

        var wkSharyoSbtList = []
        wkSharyoSbtList.push('新')
        wkSharyoSbtList.push('中')
        wkSharyoSbtList.push('下')

        self.headers = [
          { title: '配送日', name: 'sagyoYoteiYmd', type: 'customDate', validateType: 'Date', required: true, readOnly: false, width: '110px' },
          // { title: '引取先', name: 'hatsuchiNm', type: 'dropdown', source: wkHacchakuchiList, required: true, readOnly: false, width: '140px', autocomplete: true },
          // { title: '受渡先', name: 'chakuchiNm', type: 'dropdown', source: wkHacchakuchiList, required: true, readOnly: false, width: '140px', autocomplete: true },
          // { title: '担当者', name: 'sagyoTantoshaNm', type: 'dropdown', source: wkJomuinList, required: true, readOnly: false, width: '140px', autocomplete: true },
          // { title: '車種', name: 'hinmeiNm', type: 'dropdown', source: wkShohinList, required: true, readOnly: false, width: '140px', autocomplete: true },
          { title: '引取先', name: 'hatsuchiNm', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '140px' },
          { title: '受渡先', name: 'chakuchiNm', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '140px' },
          { title: '担当者', name: 'sagyoTantoshaNm', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '140px' },
          { title: '車種', name: 'hinmeiNm', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '140px' },
          { title: 'フレーム', name: 'denpyoHanyoBiko1', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '120px' },
          { title: '色', name: 'denpyoHanyoBiko2', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '80px' },
          // { title: 'お客様名', name: 'tokuisakiNm', type: 'dropdown', source: wkTokuisakiList, required: true, readOnly: false, width: '140px', autocomplete: true },
          { title: 'お客様名', name: 'tokuisakiNm', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '140px' },
          { title: '店舗', name: 'juchuEigyoshoNm', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '80px' },
          { title: '型番', name: 'denpyoHanyoBiko3', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '120px' },
          { title: 'カラーコード', name: 'denpyoHanyoBiko4', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '80px' },
          // { title: '担当者', name: 'juchuTantoshaNm', type: 'dropdown', source: wkJininList, required: true, readOnly: false, width: '160px', autocomplete: true },
          { title: '担当者', name: 'juchuTantoshaNm', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '140px' },
          { title: '扱い', name: 'denpyoHanyoSbt1', type: 'dropdown', source: wkSharyoSbtList, required: true, readOnly: false, width: '50px', autocomplete: true },
          { title: '備考', name: 'denpyoHanyoBiko5', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '120px' }
        ]
      })
    },
    rowAppendAvobe: function (num) {
      this.rowAppend(num, true)
    },
    rowAppendBelow: function (num) {
      this.rowAppend(num, false)
    },
    rowAppend: function (num, aboveFlg, lastFlg) {
      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
      } else if (activeC.length > 3) {
        // セル選択
        pos = Math.max(...[activeC[1], activeC[3]]) + 1

        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
      }

      var tmpRow = []
      for (let i = 0; i < num; i++) {
        const newrow = {
          sagyoYoteiYmd: date.getCurrentDate(),
          hatsuchiNm: null,
          chakuchiNm: null,
          sagyoTantoshaNm: null,
          hinmeiNm: null,
          denpyoHanyoBiko1: null,
          denpyoHanyoBiko2: null,
          tokuisakiNm: null,
          juchuEigyoshoNm: null,
          denpyoHanyoBiko3: null,
          denpyoHanyoBiko4: null,
          juchuTantoshaNm: null,
          denpyoHanyoSbt1: null,
          denpyoHanyoBiko5: null
        }
        tmpRow.push(newrow)
      }
      // 行追加
      if (lastFlg !== undefined && lastFlg) {
        this.rows.push(tmpRow)
        this.rows.splice()
      } else {
        if (isAllSelect || (aboveFlg !== undefined && aboveFlg)) {
          if (pos === 0) {
            this.rows.unshift(tmpRow)
          } else {
            this.rows.splice(pos - 1, 0, tmpRow)
          }
        } else {
          this.rows.splice(pos, 0, tmpRow)
        }
      }
    },

    onDummyFunction: function () {
      return null
    }
  }
}
